import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addPopUp from "./components/addPopUp";
export default {
  name: "popUpModel",
  mixins: [loadMoreList, serchSelect],
  components: {
    addPopUp: addPopUp
  },
  data: function data() {
    return {
      pagingReqFn: "activityImgPopUpList",
      pagingReqValue: "data",
      drawer: false,
      showType: {
        "1": '每次进入首页都显示',
        "2": '每天显示一次',
        "3": '只显示一次'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'payConfigurationLogDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};